const SimpleDatePickerActivityXMl =
    `<?xml version="1.0" encoding="utf-8"?>
<androidx.constraintlayout.widget.ConstraintLayout 
    xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    xmlns:tools="http://schemas.android.com/tools"
    android:layout_width="match_parent"
    android:layout_height="match_parent"
    tools:context=".MainActivity">

    <LinearLayout
        android:layout_width="match_parent"
        android:layout_height="wrap_content"
        android:orientation="vertical"
        app:layout_constraintBottom_toBottomOf="parent"
        app:layout_constraintEnd_toEndOf="parent"
        app:layout_constraintStart_toStartOf="parent"
        app:layout_constraintTop_toTopOf="parent">

        <TextView
            android:id="@+id/dateTxt"
            android:layout_width="match_parent"
            android:layout_height="wrap_content"
            android:textAlignment="center"
            android:textSize="16sp" />

        <Button
            android:id="@+id/simpleDatePickerBtn"
            android:layout_width="match_parent"
            android:layout_height="wrap_content"
            android:layout_margin="8dp"
            android:text="simple date picker" />
    </LinearLayout>
</androidx.constraintlayout.widget.ConstraintLayout>`

const SimpleDatePickerActivityKT =
    `package com.example

import android.app.DatePickerDialog
import android.os.Bundle
import android.widget.Button
import android.widget.TextView
import androidx.appcompat.app.AppCompatActivity
import java.text.SimpleDateFormat
import java.util.*


class MainActivity : AppCompatActivity() {

    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)

        // todo: Simple date picker code
        val cal = Calendar.getInstance()
        findViewById<TextView>(R.id.dateTxt).text = "--/--/----"
        val dateSetListener =
            DatePickerDialog.OnDateSetListener { _, year, monthOfYear, dayOfMonth ->
                cal.set(Calendar.YEAR, year)
                cal.set(Calendar.MONTH, monthOfYear)
                cal.set(Calendar.DAY_OF_MONTH, dayOfMonth)
                val myFormat = "dd-MMM-yyyy" // mention the format you need
                val sdf = SimpleDateFormat(myFormat, Locale.US)
                findViewById<TextView>(R.id.dateTxt).text = sdf.format(cal.time)
            }
        findViewById<Button>(R.id.simpleDatePickerBtn).setOnClickListener {
            DatePickerDialog(
                this,
                dateSetListener,
                cal.get(Calendar.YEAR),
                cal.get(Calendar.MONTH),
                cal.get(Calendar.DAY_OF_MONTH)
            ).show()
        }
        // todo: Simple date picker code
    }

}`

module.exports = {
    SimpleDatePickerActivityXMl: SimpleDatePickerActivityXMl,
    SimpleDatePickerActivityKT: SimpleDatePickerActivityKT
};